import React from 'react';
import { ApolloProvider } from 'react-apollo';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'react-router-redux';

import client from '@trello/graphql';

import { MarkdownContext } from 'gamma/components/trello-markdown';
import defaultStore from 'gamma/defaultStore';
import { TrelloMarkdownWrapper } from 'gamma/util/trello-markdown-config';

const { store, history } = defaultStore;

const markdownWrapper = new TrelloMarkdownWrapper(store);

export const ComponentWrapper = ({ children }) => (
  // Wrap these elements in a parent with the magic class that suppresses the
  // global click-handling logic (see doc-init.js#domReady method)
  <div className="js-react-root">
    <ApolloProvider client={client}>
      <Provider store={store}>
        <MarkdownContext.Provider value={markdownWrapper}>
          <ConnectedRouter history={history}>{children}</ConnectedRouter>
        </MarkdownContext.Provider>
      </Provider>
    </ApolloProvider>
  </div>
);



// WEBPACK FOOTER //
// ./app/gamma/src/components/ComponentWrapper.js